export default __webpack_public_path__ + "ca034ad879da4373d8a5234540daadb5.png";